<template>
  <section id="forgot-password-code-section" class="section-scc-portal container">
    <form id="form-forgot-password">
      <p class="p-section">Please provide following details in order to reset your password.</p>
      <div class="row container-item-form container-item-form-reset-password">
        <div class="container-input-form container-input-form-left col-sm">
          <div class="container-input-form container-input-form-left col-sm">
            <password-input
                error-message="The password you entered contains space(s), please remove it if it was added by mistake."
                message="Required field."
                label = "Password"
                :outside-error-action = "objInvalid.invalidPassword"
                name = "resetPasswordOldPassword"
                @change_resetPasswordOldPassword = "function(val){resetInformation.password = val}"
                @focus_resetPasswordOldPassword = "function(val){objInvalid.invalidPassword = val}"
            />
          </div>
        </div>
        <div class="container-input-form container-input-form-right col-sm">
        </div>
      </div>
      <div class="row container-item-form container-item-form-reset-password">
        <div class="container-input-form container-input-form-left col-sm">
          <password-input
              error-message="The password you entered contains space(s), please remove it if it was added by mistake."
              message="Required field."
              label = "New Password"
              :outside-error-action = "objInvalid.invalidNewPassword"
              name = "resetPasswordNewPassword"
              @change_resetPasswordNewPassword = "function(val){resetInformation.newPassword = val}"
              @focus_resetPasswordNewPassword = "function(val){objInvalid.invalidNewPassword = val}"
          />
        </div>
        <div class="container-input-form container-input-form-right col-sm">
          <password-input
              error-message="The password you entered contains space(s), please remove it if it was added by mistake."
              message="Required field."
              label = "New Password Confirm:"
              :outside-error-action = "objInvalid.invalidNewPasswordConfirm"
              name = "resetPasswordNewPasswordConfirm"
              @change_resetPasswordNewPasswordConfirm = "function(val){resetInformation.newPasswordConfirm = val}"
              @focus_resetPasswordNewPasswordConfirm = "function(val){objInvalid.invalidNewPasswordConfirm = val}"
          />
        </div>
      </div>
      <div id="reset-password-button" class="row container-item-form">
        <button
            type="button"
            class="button-section btn"
            @click="actionResetPassword"
        >
          RESET PASSWORD
          <i class="fa fa-chevron-right" aria-hidden="true"></i>
        </button>
      </div>
    </form>
  </section>
</template>

<script>

import xlooLib from "../../librarys/xlooLib"
import { mapState } from "vuex"
import md5 from 'md5'
import PasswordInput from "../elements/passwordInput";

export default {
  name: "resetPassword",
  components: { PasswordInput },

  data(){
    return{
      resetInformation: {
        password: '',
        newPassword: '',
        newPasswordConfirm: '',
        user_id: '',
        requestPassword: '',
        first_name: '',
        email: '',
      },
      objInvalid: {
        invalidPassword: false,
        invalidNewPassword: false,
        invalidNewPasswordConfirm: false,
      },
    }
  },
  computed : {
    ...mapState({
      passSettings: state => state.settingsAndCustomize.donorPortalSettings.passwordSettings,
    })
  },
  mounted() {

  },
  methods: {
    actionResetPassword: async function () {
      // eslint-disable-next-line no-unused-vars
      const userPasswordMD5 = await this.$store.dispatch('auth/SET_getPasswordMd5')

      if (this.resetInformation.password === '') {
        this.errorAlert('Password - Required field');
        this.objInvalid.invalidPassword = true;
        return false
      }
      if (this.resetInformation.newPassword === '') {
        this.errorAlert('New Password - Required field');
        this.objInvalid.invalidNewPassword = true;
        return false
      }
      if (this.resetInformation.newPasswordConfirm === '') {
        this.errorAlert('New Password Confirm - Required field');
        this.objInvalid.invalidNewPasswordConfirm = true;
        return
      }
      if (this.resetInformation.newPasswordConfirm !== this.resetInformation.newPassword) {
        this.errorAlert('Password does not match confirm password');
        this.objInvalid.invalidNewPassword = true;
        this.objInvalid.invalidNewPasswordConfirm = true;
        return false
      }
      const checkPassword = xlooLib.errorCheckValidationPassword(
          this.passSettings.passwordValidate.minlength,
          this.passSettings.passwordValidate.uppercase,
          this.passSettings.passwordValidate.lowercase,
          this.passSettings.passwordValidate.numbers,
          this.passSettings.passwordValidate.specialCharacters,
          this.resetInformation.newPasswordConfirm
      )
      if (checkPassword !== false) {
        this.errorAlert(checkPassword);
        this.objInvalid.invalidNewPassword = true;
        this.objInvalid.invalidNewPasswordConfirm = true;
        return
      }
      if (userPasswordMD5 !== md5(this.resetInformation.password).toUpperCase() ) {
        this.errorAlert('Unfortunately, according to the data you entered, the entered password is incorrect. Please re-enter your password.');
        this.objInvalid.invalidPassword = true;
        return
      }

      const dataRequestNewPassword = {
        newPassword: md5(this.resetInformation.newPassword).toUpperCase(),
      }
      this.$root.$emit("showSpinner");
      // eslint-disable-next-line no-unused-vars
      const resChanePass = await this.$store.dispatch('auth/SET_resetDonorPassword', dataRequestNewPassword )
      this.$root.$emit("hideSpinner");
      this.$router.push({ name: 'donorProfile'})

    },
    passwordFocusIn(){
      this.objInvalid.invalidPassword = false;
    },
    newPasswordFocusIn(){
      this.objInvalid.invalidNewPassword = false;
    },
    newPasswordConfirmFocusIn(){
      this.objInvalid.invalidNewPasswordConfirm = false;
    },
    errorAlert(message){
      this.$root.$emit('messageBox',
        {
          timeShow: 0,
          typeColor: "danger",
          textMessage: message,
        })
    },
  },
}
</script>

<style scoped>
  #reset-password-button{
    text-align: center;
  }
</style>
